import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AccountVolunteeringTableEmpty.css';

export default function AccountVolunteeringTableEmpty(props) {
  const navigate = useNavigate();
  const homeLink = `/${props.partner?.partnerLink || ''}/`;
  
  return (
    <div className="empty-info">
      {props.message && <p className="empty-info__message">{props.message}</p>}
      <button className="empty-info__btn btn btn-blue" onClick={() => navigate(homeLink)}>להוספת דיווח ראשון</button>
    </div>
  )
}
